import React from 'react';


class PrivacyPage extends React.Component {
    render() {
        return (
            <div>
<h2>Terms and Privacy Policy</h2>
Network Buddy is committed to providing you with the best possible customer service experience. Network Buddy is bound by the Privacy Act 1988 (Cth), which sets out a number of principles concerning the privacy of individuals.
<h3>Collection of your personal information</h3>
The website can be viewed without logging in, however,in order to submit events for listing or request a buddy on  Network Buddy you are required to submit personally identifiable information. This will be in the form of authorising a Facebook Login, and your identity, email address which will be provided to us by Facebook when you authorise access.
<h3>Sharing of your personal information</h3>
We may occasionally hire other companies to provide services on our behalf. Those companies will be permitted to obtain only the personal information they need to deliver the service. Network Buddy takes reasonable steps to ensure that these organisations are bound by confidentiality and privacy obligations in relation to the protection of your personal information.
<h3>Use of your personal information</h3>
For each visitor to reach the site, we expressively collect the following non-personally identifiable information, including but not limited to browser type, version and language, operating system, pages viewed while browsing the Site, page access times and referring website address. This collected information is used solely internally for the purpose of gauging visitor traffic, trends and delivering personalized content to you while you are at this Site.
<h3>Changes to this Privacy Policy</h3>
Network Buddy reserves the right to make amendments to this Privacy Policy at any time. If you have objections to the Privacy Policy, you should not access or use the Site.
<h3>Accessing Your Personal Information</h3>
You have a right to access your personal information, subject to exceptions allowed by law. If you would like to do so, please let us know. You may be required to put your request in writing for security reasons. Network Buddy reserves the right to charge a fee for searching for, and providing access to, your information on a per request basis.
<br />
<h3>Contacting us</h3>
Network Buddy welcomes your comments regarding this Privacy Policy. If you have any questions about this Privacy Policy and would like further information, please contact us by any of the following means during business hours Monday to Friday.
<br />
Network Buddy
<br />
Phone <a href="tel:03 8592 7942">03 8592 7942</a>
<br />
Email : <a href="mailto:info@networkbuddy.com.au">info@networkbuddy.com.au</a>
            </div>
        )


    }
}

export default PrivacyPage;



// WEBPACK FOOTER //
// ./src/containers/PrivacyPage.js